import styled from "styled-components";

export default styled.img`
    width: 1em;
    height: 1em;
    display: inline-block;
    margin: -0.2em 0;
    opacity: 0.9;
`